<template>
  <breadcrumb :title="title" :subTitle="subTitle" :link="link" />
  <div class="container">
    <div class="row">
        <Sidebar />
        <Password />
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/components/layouts/breadcrumb.vue";
import Sidebar from '@/components/layouts/sidebar.vue';
import Password from '@/components/include/profile/password.vue';
export default {
  data() {
    return {
      title: this.$t("change_password"),
      subTitle: "",
      link: "",
    };
  },
  components: { breadcrumb, Sidebar, Password },
};
</script>

<style>
</style>